function initVideoGallery(container = document) {
  container.querySelectorAll(".vg__carousel").forEach((slider) => {
    const swiper = slider.swiper;
    if (!swiper) return;

    const section = slider.closest('[class*="video-gallery--"]');
    const texts = section.querySelectorAll(".vg__text");
    const slides = slider.querySelectorAll(".vg__slide");
    const muted = section.dataset.muted !== "false";

    function update(index) {
      slides.forEach((slide, i) => {
        const video = slide.querySelector("video");

        if (!video) return;

        if (i === index) {
          video.muted = muted;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    update(swiper.realIndex);

    swiper.on("slideChange", () => {
      update(swiper.realIndex);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSwiper();
  initVideoGallery();
});

document.addEventListener("shopify:section:load", (event) => {
  initSwiper(event.target);
  initVideoGallery(event.target);
});